import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

export const LanguageToggle: React.FC = () => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === "es" ? "en" : "es";
    i18n.changeLanguage(newLang);
    localStorage.setItem("i18nextLng", newLang);
  };

  return (
    <Button
      variant="outline"
      size="icon"
      onClick={toggleLanguage}
      title={i18n.language === "es" ? "Cambiar a Inglés" : "Switch to Spanish"}
      className="text-muted-foreground hover:text-primary hover:border-primary/30 hover:bg-primary/10 font-bold text-xs"
    >
      {i18n.language === "es" ? "ES" : "EN"}
    </Button>
  );
};
